/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var emptyObject = {};

if (process.env.NODE_ENV !== 'production') {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;


/*****************
 ** WEBPACK FOOTER
 ** ./~/fbjs/lib/emptyObject.js
 ** module id = 136
 ** module chunks = 0
 **/